import { useEffect } from 'react';
import { useToastNotificationCallback } from './useToastNotificationCallback';

export type ToastNotification = {
  positive?: boolean;
  negative?: boolean;
  positiveMessage?: string | React.ReactNode;
  negativeMessage?: string | React.ReactNode;
  enabled?: boolean;
  onDone?: () => void;
};

export const useToastNotification = ({
  positive,
  negative,
  positiveMessage,
  negativeMessage,
  enabled,
  onDone,
}: ToastNotification) => {
  const { positive: onPositive, negative: onNegative } = useToastNotificationCallback();

  useEffect(() => {
    if (!enabled) return;
    if (negative) {
      onNegative(negativeMessage);
    } else if (positive) {
      onPositive(positiveMessage);
    }
    if (onDone) onDone();
  }, [
    negative,
    positive,
    enabled,
    onPositive,
    onNegative,
    onDone,
    negativeMessage,
    positiveMessage,
  ]);
};
